const smoothScroll = () => {
  $('a[href^="#"]').on('click', e => {
    const speed = 600;
    const href = $(e.currentTarget).attr('href');
    const target = $(href == '#' || href == '' ? 'html' : href);
    const position = target.offset().top;
    $('body, html').delay(200).animate({scrollTop: position}, speed, 'swing');
    return false;
  });
};

const btnClickFunc = () => {
  const $btns = $('.js-btn');

  $btns.on('click', e => {
    const btnTargetData = $(e.currentTarget).attr('data-btn');
    const btnAnimationData = $(e.currentTarget).attr('data-animation');
    const target = $(`[data-target = "${btnTargetData}"]`);
    const btnTargetGroupData = $(e.currentTarget).attr('data-btnGroup');
    const $sameBtns = $(`[data-btnGroup = "${btnTargetGroupData}"]`);
    const $sameTargets = $(`[data-targetGroup = "${btnTargetGroupData}"]`);

    if (btnAnimationData == 'slide') {
      $(e.currentTarget).toggleClass('js-active');
      target.slideToggle(300);
    } else if (btnAnimationData == 'class') {
      $(e.currentTarget).toggleClass('js-active');
      target.toggleClass('js-active');
    } else if (btnAnimationData == 'commonFade') {
      $sameBtns.toggleClass('js-active');
      target.fadeToggle(300);
    } else if (btnAnimationData == 'allClass') {
      $(e.currentTarget).toggleClass('js-active');
      $sameTargets.addClass('js-active');
    } else if (btnAnimationData == 'tab') {
      $sameBtns.not($(e.currentTarget)).removeClass('js-active');
      $(e.currentTarget).addClass('js-active');
      $sameTargets.removeClass('js-active');
      target.addClass('js-active');
    } else if (btnAnimationData == 'pageTop') {
      $('body, html').animate({
        scrollTop: 0
      }, 700);
      return false;
    } else {
      $(e.currentTarget).toggleClass('js-active');
    }
  });
};

const swiperSlider = () => {
  if ($('.swiper-container').length) {
    const studioPageSecuritySecSlider = new Swiper('.studioPageSecuritySec__wrap__swiper .swiper-container', {
      autoplay: {
        delay: 2000, // 自動スライド・1スライド滞在時間
        disableOnInteraction: false, // ユーザーがスライド操作した後もautoplay続行
      },
      speed: 800, // スライド切替スピード
      slidesPerView: 4, // 4スライド表示
      loop: true, // ループ(クローンスライドが作られる)
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.studioPageSecuritySec__wrap__swiper__btn .swiper-button-next',
        prevEl: '.studioPageSecuritySec__wrap__swiper__btn .swiper-button-prev',
      },
      breakpoints: {
        767: {
          slidesPerView: 1,
        },
      },
    });
  }
};

const archivePageCurrentYear = () => {
  const currentYear = $('.js-currentYear').val(); // 今いるページの年代
  const $yearList = $('.js-yearList a'); // 年代リンクリスト
  $yearList.each(function(index, link) {
    const year = $(link).text(); // 年代を取得
    if (year == currentYear) {
      $(link).addClass('current'); // 今いるページの年代と一致したらclass追加
    }
  });
};

$(function() {
  smoothScroll();
  btnClickFunc();
  swiperSlider();
  archivePageCurrentYear();
});
